import gql from 'graphql-tag';
import { UserModel } from '@ov-suite/models-idm';

export function listUsersQuery(keys: (keyof UserModel)[]) {
  return gql(`query ListUsers($orderDirection: String, $orderColumn: String, $filter: String, $limit: Int, $offset: Int) {
    listUsersWithCount(orderDirection: $orderDirection, orderColumn: $orderColumn, filter: $filter, limit: $limit, offset: $offset) {
      data {
        ${keys.join(`\n`)}
      }
      totalCount
     }
   }`);
}
